<template>
  <b-row class="cost-modal-actions">
    <b-col cols="12" sm="12" class="cost-complete-info-wrapper">
      <div class="cost-complete-info h-100" :class="costStatus">
        <b-row v-show="cost.payment_type=='notpaid'" class="h-100" align-v="center">
          <b-col cols="10" style="font-size: 13px;">
            <b-container>
              <font-awesome-icon aria-hidden="true" icon="fa-solid fa-triangle-exclamation" />
              <span v-translate>This receipt is market as not yet paid.</span>
            </b-container>
          </b-col>
        </b-row>

        <b-row v-show="!showmissingFields && cost.payment_type!='notpaid'" class="cost-info">
          <b-col cols="8" class="cost-info__msg">
            <b-container class="cost-info__msg__container">
              <font-awesome-icon aria-hidden="true" icon="fa-solid fa-triangle-exclamation" />
              <div>
                <span v-translate>Incomplete. The following fields are missing:</span>
                <span v-for="field in isCostComplete()" :key="field">{{field}}</span>
              </div>
            </b-container>
          </b-col>
          <b-col cols="4" class="cost-info__btn" style="line-height: 1;">
            <b-container>
              <GekkoButton 
                @click="$emit('toggle-complete', false)" 
                :text="$gettext('Ignore')" 
                class="text-danger p-0 border-0"
                variant="link"
                size="sm"
                style="line-height: 1;"
              />
            </b-container>
          </b-col>
        </b-row>

        <b-row v-show="showmissingFields && cost.payment_type!='notpaid'" class="cost-info">
          <b-col cols="8" class="cost-info__msg">
            <b-container class="cost-info__msg__container">
              <font-awesome-icon aria-hidden="true" icon="fa-regular fa-circle-check" />
              <span v-translate>Complete</span>
            </b-container>
          </b-col>
          <b-col cols="4" class="cost-info__btn">
            <b-container>
              <GekkoButton 
                v-if="!allFieldsFilled" 
                @click="$emit('toggle-complete', false)" 
                :text="$gettext('Undo')" 
                class="text-danger p-0"
                variant="link"
              />
            </b-container>
          </b-col>
        </b-row>

      </div>
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters } from "vuex";

import GekkoButton from "@/components/GekkoButton"

export default {
  name: 'CostStatusBadge',
  components: {
    GekkoButton,
  },
  props: {
    cost: {
      type: Object,
      default: null
    },
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({ 
      currentCompany: 'main/getCurrentCompany',
    }),
    showmissingFields () {
      return this.cost.marked_as_completed || this.isCostComplete().length === 0;
    },
    allFieldsFilled () {
      return this.isCostComplete().length === 0;
    },
    costStatus () {
      if (this.cost.payment_type === "notpaid") {
        return "notpaid";
      }
      if (this.cost.marked_as_completed || this.allFieldsFilled) {
        return "complete"
      }
      return "incomplete"
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    isCostComplete () {
      let missingFields = [];
      let taxesPresent = false;
      for (var i in this.cost.cost_lines) {
        if (this.cost.cost_lines[i].amount < 0 || this.cost.cost_lines[i].amount > 0) {
          taxesPresent = true;
          break;
        }
      }
      if (this.cost.btw_reversed_charge) {
        taxesPresent = true;
      }
      if (this.cost.tax_exempt) {
        taxesPresent = true;
      }

      if (!taxesPresent) {
        missingFields.push(" " + this.$gettext('taxes,'));
      }
      if (this.currentCompany.country === "ES") {
        if (!this.cost.subtotal_amount || this.cost.subtotal_amount == 0) {
          missingFields.push(" " + this.$gettext('amount,'));
        }
        if (!this.cost.supplier) {
          missingFields.push(" " + this.$gettext('supplier,'));
        }
        if (!this.cost.number_on_document) {
          missingFields.push(" " + this.$gettext('document number,'));
        }
      } else {
        if (!this.cost.amount || this.cost.amount == 0) {
          missingFields.push(" " + this.$gettext('amount,'));
        }
      }
      if (!this.cost.image) {
        missingFields.push(" " + this.$gettext('image,'));
      }
      if (!this.cost.cost_type) {
        missingFields.push(" " + this.$gettext('cost type,'));
      }
      if (missingFields.length>0) {
        let len = missingFields.length-1;
        missingFields[len] = missingFields[len].replace(",", ".");
      }
      return missingFields;
    },
  },
}
</script>

<style lang="scss" scoped>
  .cost-info {
    align-items: center;
    height: 100%;
    &__msg {
      font-size: 14px;
      line-height: 1;
      .svg-inline--fa { margin-right: 10px; font-size: 16px; }
      &__container {
        display: flex;
        align-items: center;
      }
    }
    &__btn {
      text-align: right;
      font-size: 14px;
    }
  }
  .cost-complete-info {
    border: none;
    border-radius: $radiusMd;
    background: lighten($colorUninvoiced, 55%);
    color: $colorUninvoiced;
    padding: 15px 0;
    .svg-inline--fa { margin-right: 5px;}
  }
  .complete {
    border: none;
    color: $colorInvoiced;
    background: lighten($colorInvoiced, 37%);
  }
  .notpaid {
    border: none;
    color: $colorUnpaid;
    background: lighten($colorUnpaid, 37%);
  }
</style>